<template>
    <div class="cover h-[450px] p-5 md:p-20 text-white bg-slate-200">
        <div class="text-white relative top-1/2 space-y-2">
            <div class="text-4xl md:text-6xl font-bold head">School outreach</div>
            <div class="uppercase text-xl font-bold mt-5">Walking with God daily</div>
        </div>
    </div>
</template>

<script setup>
defineProps(['title'])
</script>

<style scoped>
.cover{
    background: linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.5)), url('../../assets/images/bible_club.jpg');
    background-size: cover;
    background-position: center;
}
</style>